import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\GetItemWithAllRelationsByIdController::__invoke
* @see app/Http/Controllers/Item/GetItemWithAllRelationsByIdController.php
* @route '/api/item-with-relations/{item}'
*/
const GetItemWithAllRelationsByIdController = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemWithAllRelationsByIdController.url(args, options),
    method: 'get',
})

GetItemWithAllRelationsByIdController.definition = {
    methods: ["get","head"],
    url: '/api/item-with-relations/{item}',
} satisfies RouteDefinition<["get","head"]>

/**
* @see \App\Http\Controllers\Item\GetItemWithAllRelationsByIdController::__invoke
* @see app/Http/Controllers/Item/GetItemWithAllRelationsByIdController.php
* @route '/api/item-with-relations/{item}'
*/
GetItemWithAllRelationsByIdController.url = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { item: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { item: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            item: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: typeof args.item === 'object'
        ? args.item.id
        : args.item,
    }

    return GetItemWithAllRelationsByIdController.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\GetItemWithAllRelationsByIdController::__invoke
* @see app/Http/Controllers/Item/GetItemWithAllRelationsByIdController.php
* @route '/api/item-with-relations/{item}'
*/
GetItemWithAllRelationsByIdController.get = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'get'> => ({
    url: GetItemWithAllRelationsByIdController.url(args, options),
    method: 'get',
})

/**
* @see \App\Http\Controllers\Item\GetItemWithAllRelationsByIdController::__invoke
* @see app/Http/Controllers/Item/GetItemWithAllRelationsByIdController.php
* @route '/api/item-with-relations/{item}'
*/
GetItemWithAllRelationsByIdController.head = (args: { item: string | { id: string } } | [item: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'head'> => ({
    url: GetItemWithAllRelationsByIdController.url(args, options),
    method: 'head',
})

export default GetItemWithAllRelationsByIdController